import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Site office trailer.
export const TRAILER_NODES: IconNode = [
  [
    'path',
    {
      key: 'trailer-0',
      d: 'M18.2 6H3.3C2.85817 6 2.5 6.35817 2.5 6.8V14.7C2.5 15.1418 2.85817 15.5 3.3 15.5H18.2C18.6418 15.5 19 15.1418 19 14.7V6.8C19 6.35817 18.6418 6 18.2 6Z',
    },
  ],
  [
    'path',
    {
      key: 'trailer-1',
      d: 'M19 10.5H21.6',
    },
  ],
  [
    'path',
    {
      key: 'trailer-2',
      d: 'M9.2 8.5H5V11.7H9.2V8.5Z',
    },
  ],
  [
    'path',
    {
      key: 'trailer-3',
      d: 'M16.6001 8.8999H12.6001V15.4999H16.6001V8.8999Z',
    },
  ],
  [
    'path',
    {
      key: 'trailer-4',
      d: 'M11.8 17.8999H17',
    },
  ],
  [
    'path',
    {
      key: 'trailer-5',
      d: 'M5.5 15.5V17.9',
    },
  ],
]

export const TrailerIcon: LucideIcon = createLucideIcon(
  'trailer',
  TRAILER_NODES,
)
